export { DownloadIcon } from './DownloadIcon'
export { BookIcon } from './BookIcon'
export { ChevronRight } from './ChevronRight'
export { ReactComponent as PoliciesPurpleSVG } from './icons_policies_purple.svg'

import styled from 'styled-components/macro'
import {
  ColorProps,
  compose,
  margin,
  MarginProps,
  position,
  PositionProps,
  system,
} from 'styled-system'
import { ReactComponent as OriginalPlusSVG } from 'src/components/Icons/assets/plus-icon.svg'

import { ReactComponent as OriginalVerticalEllipsesIcon } from '../assets/vertical-ellipses-icon.svg'
import { ReactComponent as OriginalDeleteSVG } from '../assets/delete-icon.svg'
import { ReactComponent as OriginalRisksSVG } from './icons_warning_gear.svg'
import { ReactComponent as OriginalControlsSVG } from './icons_controls.svg'
import { DownloadIcon } from './DownloadIcon'
import { ReactComponent as OriginalActivateSVG } from './icons_activate.svg'
import { ReactComponent as OriginalCheckSVG } from './icons_check.svg'
import { ReactComponent as OriginalChevronSVG } from './icons_chevron.svg'
import { ReactComponent as OriginalFrameworksSVG } from './icons_frameworks.svg'
import { ReactComponent as OriginalAuditSVG } from './icons_audit.svg'
import { ReactComponent as OriginalReceptorsSVG } from './icons_services.svg'
import { ReactComponent as OriginalCompanyInfoSVG } from './icons_company_info.svg'
import { ReactComponent as OriginalDescriptionSVG } from './icons_description.svg'
import { ReactComponent as OriginalDropdownSVG } from './icons_dropdown.svg'
import { ReactComponent as OriginalDropdownDarkSVG } from './icons_dropdown_dark.svg'
import { ReactComponent as OriginalCopySVG } from './icons_copy.svg'
import { ReactComponent as OriginalEditSVG } from './icons_edit.svg'
import { ReactComponent as OriginalXSVG } from './icons_x.svg'
import { ReactComponent as OriginalEvidenceSVG } from './icons_evidence.svg'
import { ReactComponent as OriginalFixitSVG } from './icons_fixit.svg'
import { ReactComponent as OriginalInfoSVG } from './icons_info.svg'
import { ReactComponent as OriginalKeySVG } from './icons_key.svg'
import { ReactComponent as OriginalPoliciesSVG } from './icons_policies.svg'
import { ReactComponent as OriginalRequestsSVG } from './icons_requests.svg'
import { ReactComponent as OriginalSortNoneSVG } from './icons_sort_none.svg'
import { ReactComponent as OriginalSortAscSVG } from './icons_sort_asc.svg'
import { ReactComponent as OriginalSortDescSVG } from './icons_sort_desc.svg'
import { ReactComponent as OriginalTestSVG } from './icons_test.svg'
import { ReactComponent as OriginalAuditBotSVG } from './icons_auditbot.svg'
import { ReactComponent as OriginalCircleMinusSVG } from './icons_circle_minus.svg'
import { ReactComponent as OriginalMinusSVG } from './icons_minus.svg'
import { ReactComponent as OriginalForwardSVG } from './icons_forward.svg'
import { ReactComponent as OriginalMoveToSVG } from './icons_move_to.svg'
import { ReactComponent as OriginalQuestionMarkSVG } from './icons_questionmark.svg'
import { ReactComponent as OriginalPanelCollapseEastSVG } from './icons_panel_collapse_east.svg'
import { ReactComponent as OriginalPanelCollapseWestSVG } from './icons_panel_collapse_west.svg'
import { ReactComponent as OriginalPanelExpandEastSVG } from './icons_panel_expand_east.svg'
import { ReactComponent as OriginalPanelExpandWestSVG } from './icons_panel_expand_west.svg'
import { ReactComponent as OriginalGrcSVG } from './icons_grc.svg'
import { ReactComponent as OriginalKbDocumentSVG } from './icons_kb_document.svg'
import { ReactComponent as OriginalUploadSVG } from './icons_upload.svg'
import { ReactComponent as OriginalEyeVisible } from './icons_eye.svg'
import { ReactComponent as OriginalEyeInvisible } from './icons_eye_slash.svg'
import { ReactComponent as OriginalServicesSVG } from './icons_services.svg'
import { ReactComponent as OriginalPlatformDocumentSVG } from './icons_platform_document.svg'
import { ReactComponent as OriginalFileUploadSVG } from './icons_file_upload.svg'
import { ReactComponent as OriginalThumbsUpSVG } from './icons_thumbs_up.svg'
import { ReactComponent as OriginalThumbsDownSVG } from './icons_thumbs_down.svg'
import { ReactComponent as OriginalClipboardSVG } from './icons_clipboard.svg'
import { ReactComponent as OriginalGroupSVG } from './icons_group.svg'
import { ReactComponent as OriginalPrivateSVG } from './icons_private.svg'
import { ReactComponent as OriginalPublicSVG } from './icons_public.svg'
import { ReactComponent as OriginalNewPermalinkSVG } from './icons_new_permalink.svg'
import { ReactComponent as OriginalNewHistorySVG } from './icons_new_history.svg'
import { ReactComponent as OriginalContextSVG } from './icons_context.svg'
import { ReactComponent as OriginalArtifactSVG } from './icons_artifact.svg'
import { ReactComponent as OriginalChatsSVG } from './icons_chats.svg'
import { ReactComponent as OriginalAddSVG } from './icons_add.svg'
import { ReactComponent as OriginalSubtractSVG } from './icons_subtract.svg'
import { ReactComponent as OriginalSendMessageSVG } from './icons_send_message.svg'
import { ReactComponent as OriginalArtifactDataSVG } from './icons_artifact_data.svg'

import { ReactComponent as OriginalSignOutSVG } from './icons_signout.svg'
import { ReactComponent as OriginalBadgeInfoSVG } from './icons_badge_info.svg'
import { ReactComponent as OriginalBadgeWarningSVG } from './icons_badge_warning.svg'
import { ReactComponent as OriginalBadgeErrorSVG } from './icons_badge_error.svg'
import { ReactComponent as OriginalBadgeSuccessSVG } from './icons_badge_success.svg'
import { ReactComponent as OriginalBadgePendingSVG } from './icons_badge_pending.svg'
import { ReactComponent as OriginalBadgeMinusSVG } from './icons_badge_minus.svg'
import { ReactComponent as OriginalFullWarningSVG } from './icons_full_warning.svg'
import { ReactComponent as OriginalFullInfoSVG } from './icons_full_info.svg'
import { ReactComponent as OriginalFullErrorSVG } from './icons_full_error.svg'
import { ReactComponent as OriginalFullSuccessSVG } from './icons_full_success.svg'
import { ReactComponent as OriginalSearchSVG } from './icons_search.svg'
import { ReactComponent as OriginalAdvancedSearchSVG } from './icons_advanced_search.svg'
import { ReactComponent as OriginalCloseSVG } from './icons_close.svg'
import { ReactComponent as OriginalMoreUpSVG } from './icons_more_up.svg'
import { ReactComponent as OriginalMoreDownSVG } from './icons_more_down.svg'
import { ReactComponent as OriginalCloseIcon } from './icons_close.svg'
import { ReactComponent as OriginalContentMatchSVG } from './icons_content_match.svg'
import { ReactComponent as OriginalDownloadArrowSVG } from './icons_download_arrow.svg'
import { ReactComponent as OriginalExpandSVG } from './icons_expand.svg'
import { ReactComponent as OriginalTargetSVG } from './icons_target.svg'
import { ReactComponent as OriginalPrintSVG } from './icons_print.svg'
import { ReactComponent as OriginalCalendarSVG } from './icons_calendar.svg'
import { ReactComponent as OriginalFileAttachmentSVG } from './icons_file_attachment.svg'
import { ReactComponent as OriginalPlaybookSVG } from './icons_playbook.svg'
import { ReactComponent as OriginalStarSVG } from './icons_star.svg'
import { ReactComponent as OriginalCommentSVG } from './icons_comment.svg'
import { ReactComponent as OriginalTailoredCommentSVG } from './icons_tailored_comment.svg'
import { ReactComponent as OriginalPageSVG } from './icons_page.svg'
import { ReactComponent as OriginalMoveUpSVG } from './icons_move_up.svg'
import { ReactComponent as OriginalMoveDownSVG } from './icons_move_down.svg'
import { ReactComponent as OriginalEroDarkInverseSVG } from './icons_ero_dark.svg'
import { ReactComponent as OriginalEroGreenSVG } from './icons_ero.svg'
import { ReactComponent as OriginalIconFindingsSVG } from './icons_findings.svg'
import { ReactComponent as OriginalIconRecommendationsSVG } from './icons_recommendations.svg'
import { ReactComponent as OriginalIconCommentMentionSVG } from './icons_comment_mention.svg'

type Props = PositionProps & ColorProps & MarginProps

const fill = system({
  fill: {
    property: 'fill',
    scale: 'colors',
  },
})

export const ActivateSVG = styled(OriginalActivateSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CheckSVG = styled(OriginalCheckSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CircleMinusSVG = styled(OriginalCircleMinusSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ForwardSVG = styled(OriginalForwardSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const MoveToSVG = styled(OriginalMoveToSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const MinusSVG = styled(OriginalMinusSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const QuestionMarkSVG = styled(OriginalQuestionMarkSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ChevronSVG = styled(OriginalChevronSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const ControlsSVG = styled(OriginalControlsSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const FrameworksSVG = styled(OriginalFrameworksSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const AuditsSVG = styled(OriginalAuditSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const ReceptorsSVG = styled(OriginalReceptorsSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const CompanyInfoSVG = styled(OriginalCompanyInfoSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const DescriptionSVG = styled(OriginalDescriptionSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const DownloadSVG = DownloadIcon

export const DropdownSVG = styled(OriginalDropdownSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const DropdownDarkSVG = styled(OriginalDropdownDarkSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const CopySVG = styled(OriginalCopySVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const EditSVG = styled(OriginalEditSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const SignOutSVG = styled(OriginalSignOutSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const XSVG = styled(OriginalXSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const EvidenceSVG = styled(OriginalEvidenceSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const FixitSVG = styled(OriginalFixitSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const InfoSVG = styled(OriginalInfoSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const KeySVG = styled(OriginalKeySVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PoliciesSVG = styled(OriginalPoliciesSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const RequestsSVG = styled(OriginalRequestsSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const RisksSVG = styled(OriginalRisksSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const AuditBotSVG = styled(OriginalAuditBotSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const TestSVG = styled(OriginalTestSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const SortNoneSvg = styled(OriginalSortNoneSVG).withConfig({
  shouldForwardProp: (prop) => {
    return !['sortingOrder'].includes(prop)
  },
})<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const SortAscSvg = styled(OriginalSortAscSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const SortDescSvg = styled(OriginalSortDescSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PanelCollapseEastSvg = styled(OriginalPanelCollapseEastSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PanelCollapseWestSvg = styled(OriginalPanelCollapseWestSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PanelExpandEastSvg = styled(OriginalPanelExpandEastSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
export const PanelExpandWestSvg = styled(OriginalPanelExpandWestSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const GrcSVG = styled(OriginalGrcSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const KbDocumentSVG = styled(OriginalKbDocumentSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const UploadSVG = styled(OriginalUploadSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const DeleteSVG = styled(OriginalDeleteSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const EyeVisibleSVG = styled(OriginalEyeVisible)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const EyeInvisibleSVG = styled(OriginalEyeInvisible)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ServicesSVG = styled(OriginalServicesSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PlatformDocumentSVG = styled(OriginalPlatformDocumentSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const FileUploadSVG = styled(OriginalFileUploadSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const VerticalEllipsesSVG = styled(OriginalVerticalEllipsesIcon)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ThumbsUpSVG = styled(OriginalThumbsUpSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const BadgeInfoSVG = styled(OriginalBadgeInfoSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ThumbsDownSVG = styled(OriginalThumbsDownSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const FullInfoSVG = styled(OriginalFullInfoSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ClipboardSVG = styled(OriginalClipboardSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const BadgeWarningSVG = styled(OriginalBadgeWarningSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const GroupSVG = styled(OriginalGroupSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const FullWarningSVG = styled(OriginalFullWarningSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const BadgeErrorSVG = styled(OriginalBadgeErrorSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const FullErrorSVG = styled(OriginalFullErrorSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ErrorSVG = BadgeErrorSVG

export const BadgeSuccessSVG = styled(OriginalBadgeSuccessSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CircleCheckSVG = BadgeSuccessSVG
export const CircleCheckFillSVG = BadgeSuccessSVG

export const FullSuccessSVG = styled(OriginalFullSuccessSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const BadgePendingSVG = styled(OriginalBadgePendingSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CircleQuestionMarkSVG = BadgePendingSVG

export const BadgeMinusSVG = styled(OriginalBadgeMinusSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CircleMinusGreySVG = BadgeMinusSVG

export const WarningFullSVG = styled(OriginalFullWarningSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const SearchSVG = styled(OriginalSearchSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const AdvancedSearchSVG = styled(OriginalAdvancedSearchSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ContentMatchSVG = styled(OriginalContentMatchSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PublicSVG = styled(OriginalPublicSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const DownloadArrowSVG = styled(OriginalDownloadArrowSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const NewPermalinkSVG = styled(OriginalNewPermalinkSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ExpandSVG = styled(OriginalExpandSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CloseSVG = styled(OriginalCloseSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const MoreUpSVG = styled(OriginalMoreUpSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const MoreDownSVG = styled(OriginalMoreDownSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CloseIconSVG = styled(OriginalCloseIcon)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PrivateSVG = styled(OriginalPrivateSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const NewHistorySVG = styled(OriginalNewHistorySVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ContextSVG = styled(OriginalContextSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ArtifactSVG = styled(OriginalArtifactSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ChatsSVG = styled(OriginalChatsSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const AddSVG = styled(OriginalAddSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const SubtractSVG = styled(OriginalSubtractSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const SendMessageSVG = styled(OriginalSendMessageSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const ArtifactDataSVG = styled(OriginalArtifactDataSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const TargetSVG = styled(OriginalTargetSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PrintSVG = styled(OriginalPrintSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CalendarSVG = styled(OriginalCalendarSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const FileAttachmentSVG = styled(OriginalFileAttachmentSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PlaybookSVG = styled(OriginalPlaybookSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const StarSVG = styled(OriginalStarSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PlusSVG = styled(OriginalPlusSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const CommentSVG = styled(OriginalCommentSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const TailoredCommentSVG = styled(OriginalTailoredCommentSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const PageSVG = styled(OriginalPageSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const MoveUpSVG = styled(OriginalMoveUpSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const MoveDownSVG = styled(OriginalMoveDownSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const EroDarkInverseSVG = styled(OriginalEroDarkInverseSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const EroGreenSVG = styled(OriginalEroGreenSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const IconFindingsSVG = styled(OriginalIconFindingsSVG)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const IconRecommendationsSVG = styled(
  OriginalIconRecommendationsSVG,
)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`

export const StyledIcon = styled.div<{
  height?: number
  width?: number
  fontSize?: number
  color?: string
  margin?: string
}>`
  height: ${({ height }) => (height ? `${height}px` : '24px')};
  width: ${({ width }) => (width ? `${width}px` : '24px')};
  font-family: 'Font Awesome 6 Free';
  font-style: normal;
  font-weight: 900;
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '24px')};
  line-height: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '24px')};
  color: ${({ color }) => color || '#586c7f'};
  flex: none;
  order: 0;
  flex-grow: 0;
  ${({ margin }) => margin && `margin: ${margin}`};
`

export const IconCommentMentionSVG = styled(
  OriginalIconCommentMentionSVG,
)<Props>`
  ${compose(position, margin)}
  path {
    ${fill}
  }
`
